import { ErrorView } from 'shared/components/ErrorView';

export const Unauthorized = () => {
    return <ErrorView title="403" message="Sorry, you don't have the required role to access this page." />;
};
